export function mountBlurGradientHeadings(root = document) {
	const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
	const observer = "IntersectionObserver" in window ? new IntersectionObserver((entries) => {
		entries.forEach(({ target, isIntersecting }) => {
			if (!isIntersecting) return;
			observer.unobserve(target);
			if (reducedMotion.matches) return;
			const words = target.querySelectorAll(".solufy-heading-word");
			words.forEach((word, index) => {
				word.animate([
					{ filter: "blur(10px)", opacity: 0, transform: "translateY(-50px)" },
					{ filter: "blur(5px)", opacity: 0.5, transform: "translateY(5px)", offset: 0.5 },
					{ filter: "blur(0px)", opacity: 1, transform: "translateY(0)" },
				], { duration: 550, delay: index * 90, easing: "linear", fill: "backwards" });
			});
		});
	}, { threshold: 0.1 }) : null;

	root.querySelectorAll(".solufy-site :is(h1, h2)").forEach((heading) => {
		if (heading.closest("footer")) return;
		if (heading.closest(".solufy-case-content")) return;
		if (heading.tagName === "H2" && parseFloat(window.getComputedStyle(heading).fontSize) < 28) return;
		if (heading.dataset.blurGradientMounted) return;
		heading.dataset.blurGradientMounted = "true";
		heading.removeAttribute("data-motion-text");
		const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
		const nodes = [];
		while (walker.nextNode()) nodes.push(walker.currentNode);
		const words = [];
		nodes.forEach((node) => {
			if (node.parentElement.closest("svg, script, style, [aria-hidden='true']")) return;
			const fragment = document.createDocumentFragment();
			node.textContent.split(/(\s+)/).forEach((text) => {
				if (!text || /^\s+$/.test(text)) {
					fragment.appendChild(document.createTextNode(text));
					return;
				}
				const word = document.createElement("span");
				word.className = "solufy-heading-word";
				word.textContent = text;
				words.push(word);
				fragment.appendChild(word);
			});
			node.replaceWith(fragment);
		});
		observer?.observe(heading);
	});
	return () => observer?.disconnect();
}
